import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import AuthCallback from '@/pages/AuthCallback';
import EmailAuth from '@/pages/EmailAuth';
import Dashboard from '@/pages/Dashboard';
import Chat from '@/pages/Chat';
import Feed from '@/pages/Feed';
import FlowerExchange from '@/pages/FlowerExchange';
import AdminLogin from '@/pages/AdminLogin';
import AdminFlowerExchange from '@/pages/AdminFlowerExchange';
import AdminUsers from '@/pages/AdminUsers';
import Donate from '@/pages/Donate';
import DonateSuccess from '@/pages/DonateSuccess';
import Merch from '@/pages/Merch';
import MerchSuccess from '@/pages/MerchSuccess';
import Profile from '@/pages/Profile';
import ProtectedRoute from '@/components/ProtectedRoute';
import ProtectedAdminRoute from '@/components/ProtectedAdminRoute';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<EmailAuth />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
      <Route path="/flower-exchange" element={<ProtectedRoute><FlowerExchange /></ProtectedRoute>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/flower-exchange" element={<ProtectedAdminRoute><AdminFlowerExchange /></ProtectedAdminRoute>} />
      <Route path="/admin/users" element={<ProtectedAdminRoute><AdminUsers /></ProtectedAdminRoute>} />
      <Route path="/donate" element={<Donate />} />
      <Route path="/donate/success" element={<DonateSuccess />} />
      <Route path="/merch" element={<Merch />} />
      <Route path="/merch/success" element={<MerchSuccess />} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain-overlay">
      <BrowserRouter>
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;